// //@ts-nocheck
// import React from 'react';
// import { Document, Page, pdfjs } from 'react-pdf';
// import 'react-pdf/dist/Page/AnnotationLayer.css';
// import 'react-pdf/dist/Page/TextLayer.css';

// function JobResumeSection({ resumeData }) {
//   pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//     'pdfjs-dist/build/pdf.worker.min.mjs',
//     import.meta.url,
//   ).toString();

//   const [numPages, setNumPages] = React.useState();
//   const [pageNumber, setPageNumber] = React.useState(1);
//   const [pdfError, setPdfError] = React.useState(false);

//   // Function to handle document load success
//   function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
//     setNumPages(numPages);
//     setPdfError(false); // Reset error state on successful load
//   }

//   // Function to handle document load error
//   function onDocumentLoadError(error: Error): void {
//     console.error('Failed to load PDF:', error);
//     setPdfError(true); // Set error state if PDF fails to load
//   }

//   const pdfUrl = `${process.env.REACT_APP_API_BASE_URL}/${resumeData}`;

//   return (
//     <div className="w-full">
//       {pdfError ? (
//         <div className="pdf-error m-auto text-center">
//           <p>Failed to load PDF. You can download it from the link below:</p>
//           <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className='text-blue-500'>
//             {pdfUrl}
//           </a>
//         </div>
//       ) : (
//         <div className="pdf-container">
//           <Document
//             file={pdfUrl}
//             onLoadSuccess={onDocumentLoadSuccess}
//             onLoadError={onDocumentLoadError}
//           >
//           </Document>
//         </div>
//       )}

//       {/* Pagination controls */}
//       {!pdfError && (
//         <div className="flex justify-center mt-8 items-center">
//           <button
//             className='mr-1 inline-flex shrink-0  justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
//             onClick={() => setPageNumber((prev) => Math.max(prev - 1, 1))}
//             disabled={pageNumber <= 1}
//           >
//             Previous
//           </button>
//           <span className='text-[0.8125rem] font-medium leading-5 text-[#1b1b1b] mx-2'>
//             Page {pageNumber} of {numPages}
//           </span>
//           <button
//             className='ml-1 inline-flex shrink-0  justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
//             onClick={() => setPageNumber((prev) => Math.min(prev + 1, numPages))}
//             disabled={pageNumber >= numPages}
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }

// export default JobResumeSection;

//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { CrossIcon } from '../icons/Icons';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

function JobResumeSection({ resumeData, sidebarOpen, quickData, fromResumeTab }) {
  
  pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
  ).toString();

  const [numPages, setNumPages] = React.useState(null);
  const [pdfError, setPdfError] = React.useState(false);
  const [scale, setScale] = useState(1.5); // Default scale for desktop
  const [isLoading, setIsLoading] = useState(true); // State to track loading status
  const [resumeZoomOpen, setResumeZoomOpen] = useState(false)
  const [modalScale, setModalScale] = useState(1.8); // Scale for modal view

  // Function to handle document load success
  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
    setPdfError(false); // Reset error state on successful load
    setIsLoading(false); // Set loading to false once the PDF is loaded
  }

  // Function to handle document load error
  function onDocumentLoadError(error: Error): void {
    console.error('Failed to load PDF:', error);
    setPdfError(true); // Set error state if PDF fails to load
    setIsLoading(false); // Set loading to false on error
  }

  // Function to update scale based on screen width
  const updateScale = () => {
    const screenWidth = window.innerWidth;
    if (sidebarOpen && screenWidth >= 1300 && screenWidth <= 1800) {
      setScale(0.9); // Set scale to 1.1 when sidebar is open and screen is 1300-1800px
    } else if (sidebarOpen) {
      setScale(1.5); // Set scale to 1.5 when sidebar is open for other screen sizes
    } else if (screenWidth >= 1300 && screenWidth <= 1500) {
      setScale(1);
    } else {
      setScale(1.5);
    }
  };



  // Effect to update scale on window resize
  useEffect(() => {
    updateScale();
    window.addEventListener('resize', updateScale);
    return () => window.removeEventListener('resize', updateScale);
  }, [sidebarOpen]); // Re-run effect when sidebarOpen changes

  const pdfUrl = `${process.env.REACT_APP_API_BASE_URL}/${resumeData}`;

  const handleOpenResume = () => {
    setResumeZoomOpen(!resumeZoomOpen)
  }

  // Custom loading component
  const LoadingSpinner = () => (
    <div className="flex items-center justify-center relative z-50" style={{ height: "100px" }}>
      <div className="simple-spinner-loader">
        <span></span>
      </div>
    </div>
  );

  return (
    <div className="w-full">
      {pdfError ? (
        <div className="pdf-error m-auto text-center">
          <p>Failed to load PDF. You can download it from the link below:</p>
          <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className='text-blue-500'>
            {pdfUrl}
          </a>
        </div>
      ) : (
        <div className="pdf-container">


          <div

            className={`w-full flex justify-end mb-5 
                      ${sidebarOpen
                ? fromResumeTab
                  ? 'mq1800:ml-[10px] mq3000:ml-[-11rem]'
                  : ' mq1800:ml-[18px] mq3000:ml-[-3rem]' // fallback or other default
                : fromResumeTab
                  ? 'mq1800:ml-[-10px] mq3000:ml-[-32px]'
                  : ' mq1800:ml-[-110px] mq3000:ml-[-198px]' // fallback for non-resume tab
              }`}

          >
            <button
              data-title={"Zoom"}
              onClick={handleOpenResume}
              style={{ transitionProperty: 'background-color,border-color,color,fill,stroke,opacity,box-shadow,transform' }}
              className='table-tooltip before:!bottom-[-32px] before:!left-[20px] rounded-md shadow-sm shadow-black/5 duration-200 
                        font-[600] text-[0.8125rem] h-[28px] w-[28px] flex items-center justify-center border border-solid border-[#e7e7e8]'>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-zoom-scan w-[1rem] h-[1rem] text-[#808080]"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M4 8v-2a2 2 0 0 1 2 -2h2" />
                <path d="M4 16v2a2 2 0 0 0 2 2h2" />
                <path d="M16 4h2a2 2 0 0 1 2 2v2" />
                <path d="M16 20h2a2 2 0 0 0 2 -2v-2" />
                <path d="M8 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                <path d="M16 16l-2.5 -2.5" />
              </svg>

            </button>
          </div>
          {/* <h2 className="text-[18px] lg:text-[18px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem] capitalize mb-5" >Resume</h2> */}
          {
            quickData &&
            <Document
              file={pdfUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={onDocumentLoadError}
              loading={<LoadingSpinner />} // Pass the custom loading component
            >
              {Array.from(new Array(numPages), (_, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  scale={0.8}
                />
              ))}
            </Document>
          }

          {
            !quickData &&
            <Document
              file={pdfUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={onDocumentLoadError}
              loading={<LoadingSpinner />} // Pass the custom loading component
            >
              {Array.from(new Array(numPages), (_, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  scale={scale}
                />
              ))}
            </Document>
          }
        </div>
      )}





      <Dialog open={resumeZoomOpen} onClose={setResumeZoomOpen} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full
               sm:max-w-[90rem] sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              {/* <h3 className='text-base font-semibold leading-6 text-gray-900 mb-4'>Resume</h3> */}
              <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setResumeZoomOpen(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon aria-hidden="true" className="size-6" />
                </button>
              </div>

              {/* PDF Viewer in Modal */}
              <div className="max-h-[80vh] overflow-y-auto">
                {pdfError ? (
                  <div className="pdf-error m-auto text-center">
                    <p>Failed to load PDF. You can download it from the link below:</p>
                    <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className='text-blue-500'>
                      {pdfUrl}
                    </a>
                  </div>
                ) : (
                  <div className="pdf-container flex flex-col items-center">
                    <Document
                      file={pdfUrl}
                      onLoadSuccess={onDocumentLoadSuccess}
                      onLoadError={onDocumentLoadError}
                      loading={<LoadingSpinner />}
                    >
                      {Array.from(new Array(numPages), (_, index) => (
                        <div key={`modal_page_${index + 1}`} className="mb-4 shadow-lg">
                          <Page
                            pageNumber={index + 1}
                            scale={modalScale}
                          />
                        </div>
                      ))}
                    </Document>
                  </div>
                )}
              </div>

            </DialogPanel>
          </div>
        </div>
      </Dialog>

    </div>
  );
}

export default JobResumeSection;